var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _vm._l(_vm.value, function(item, i) {
          return _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.type,
                        expression: "item.type"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.getError(_vm.field + "." + i + ".type")
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          item,
                          "type",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "work" } }, [
                      _vm._v(
                        "\n                            Work\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "home" } }, [
                      _vm._v(
                        "\n                            Home\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "mobile" } }, [
                      _vm._v(
                        "\n                            Mobile\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "work_fax" } }, [
                      _vm._v(
                        "\n                            Work Fax\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "private_fax" } }, [
                      _vm._v(
                        "\n                            Private Fax\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "other" } }, [
                      _vm._v(
                        "\n                            Other\n                        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-feedback" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.getError(_vm.field + "." + i + ".type")) +
                      "\n                    "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-8" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: item.value,
                      expression: "item.value"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    "is-invalid": _vm.getError(_vm.field + "." + i + ".value")
                  },
                  attrs: { type: "text", placeholder: "Phone Number" },
                  domProps: { value: item.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(item, "value", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-feedback" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.getError(_vm.field + "." + i + ".value")) +
                      "\n                    "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-sm-1",
                staticStyle: { "padding-bottom": "10px" }
              },
              [
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-danger",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          return _vm.onRemove(item)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-trash" })]
                  )
                ])
              ]
            )
          ])
        }),
        _vm._v(" "),
        _vm.value.length === 0
          ? _c("div", { staticClass: "text-center" }, [
              _vm._v("\n            No phone numbers.\n        ")
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "card-footer" }, [
      _c("div", { staticClass: "d-flex justify-content-end" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-default",
            attrs: { href: "javascript:;" },
            on: { click: _vm.onInsert }
          },
          [
            _c("i", { staticClass: "fas fa-plus" }),
            _vm._v(" Add\n            ")
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }